/** Keep candidate widths and CDN eligibility aligned with Deals\Model\ResponsiveImage. */
export const imageWidths = [320, 480, 640, 800, 1200];

export function isResizableImage(source: string): boolean {
    try {
        const url = new URL(source);
        return (url.protocol === 'http:' || url.protocol === 'https:')
            && url.hostname.toLowerCase().indexOf('images.') === 0
            && source.indexOf('?') === -1 && source.indexOf('#') === -1;
    } catch (_) {
        return false;
    }
}

export function imageSrcset(source: string): string | undefined {
    return isResizableImage(source)
        ? imageWidths.map(width => `${source}?w=${width}&fm=webp ${width}w`).join(', ')
        : undefined;
}

export function imageFallback(source: string): string {
    return !source ? '/img/image-placeholder.jpg'
        : isResizableImage(source) ? `${source}?w=800&fm=jpg` : source;
}

/** #wrapper is fluid on tablets, 1024px on desktop, then grows to 1408px. */
export function cardImageSizes(featured: boolean): string {
    // Avoid min()/max() in sizes for older Safari, and end with a plain px fallback.
    const desktop = featured ? 464 : 299;
    const fluid = featured ? 'calc(37.5vw - 48px)' : 'calc(25vw - 42.667px)';
    const maximum = featured ? 656 : 427;
    return `(max-width: 743px) calc(100vw - 32px), (max-width: 1023px) calc(50vw - 48px), `
        + `(max-width: 1365px) ${desktop}px, (max-width: 1877px) ${fluid}, ${maximum}px`;
}
